import { createApi } from "@reduxjs/toolkit/query/react";
import { tokenQuery } from "./tokenQuery";

const tripAPI = createApi({
    reducerPath: "calculatorAPI",
    baseQuery: tokenQuery,
    endpoints: (builder) => ({
        getTours: builder.mutation({
            query: ({page, size, staffId, searchKey, fromDate, toDate, month}) => {
                let url = `tour-calculation?page=${page}&size=${size}`;

                if(staffId){
                    url += `&staffId=${staffId}`
                }

                if(searchKey){
                    url += `&key=${searchKey}`
                }

                if(fromDate){
                    url += `&fromDate=${fromDate}`
                }

                if(toDate){
                    url += `&toDate=${toDate}`
                }

                if(month){
                    url += `&month=${month}`
                }

                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        saveATour: builder.mutation({
            query: ({body}) => {
                const apiUrl = `tour-calculation`;

                return {
                    url: apiUrl,
                    method: "POST",
                    body: body
                };
            },
            transformResponse: (response) => response
        }),
        editATour: builder.mutation({
            query: ({id, request}) => {
                const apiUrl = `tour-calculation/${id}`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body: request
                };
            },
            transformResponse: (response) => response
        }),
        deleteATour: builder.mutation({
            query: ({id, staffId}) => {
                let url = `tour-calculation/${id}`;
                if(staffId){
                    url += `?staffId=${staffId}`
                }
                return {
                    url,
                    method: "DELETE"
                };
            },
            transformResponse: (response) => response
        }),
        deleteAllTours: builder.mutation({
            query: ({staffId}) => {
                let url = staffId
                    ? `tour-calculation/all/${staffId}`
                    : `tour-calculation/all/undefined`;
                return {
                    url,
                    method: "DELETE"
                };
            },
            transformResponse: (response) => response
        })
    })
});

export const { 
    useGetToursMutation,
    useSaveATourMutation,
    useEditATourMutation,
    useDeleteATourMutation,
    useDeleteAllToursMutation
} = tripAPI;

export default tripAPI;